import { register } from "@rill/loader";

register(
  {
    name: "pushDashboardDefaults",
    meta: [
      "no-bust",
      "client-configuration-push-dashboard-defaults",
      // The `featureStatus` of the response depends on published widgets and programs
      "widget",
      "cycle",
    ],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const res = await api("client-configurations/push-dashboard-defaults");
    return res.json();
  }
);
